/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Feedback_LeadInputs */

const en_us2_workout_after_feedback_lead = /** @type {(inputs: Workout_After_Feedback_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It takes half a minute. Your trainer uses it to adjust the next workout.`)
};

const pt_br2_workout_after_feedback_lead = /** @type {(inputs: Workout_After_Feedback_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leva meio minuto. Seu personal usa isso para ajustar o próximo treino.`)
};

const es_419_workout_after_feedback_lead = /** @type {(inputs: Workout_After_Feedback_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toma medio minuto. Tu entrenador lo usa para ajustar el próximo entrenamiento.`)
};

const pt_pt2_workout_after_feedback_lead = /** @type {(inputs: Workout_After_Feedback_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demora meio minuto. O teu treinador usa isto para ajustar o próximo treino.`)
};

const fr_fr2_workout_after_feedback_lead = /** @type {(inputs: Workout_After_Feedback_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça prend trente secondes. Ton coach s'en sert pour ajuster la prochaine séance.`)
};

const de_de2_workout_after_feedback_lead = /** @type {(inputs: Workout_After_Feedback_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauert eine halbe Minute. Dein Coach nutzt es, um das nächste Training anzupassen.`)
};

const it_it2_workout_after_feedback_lead = /** @type {(inputs: Workout_After_Feedback_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ci vuole mezzo minuto. Il coach lo usa per regolare il prossimo allenamento.`)
};

/**
* | output |
* | --- |
* | "It takes half a minute. Your trainer uses it to adjust the next workout." |
*
* @param {Workout_After_Feedback_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_feedback_lead = /** @type {((inputs?: Workout_After_Feedback_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Feedback_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_feedback_lead(inputs)
	if (locale === "es-419") return es_419_workout_after_feedback_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_feedback_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_feedback_lead(inputs)
	if (locale === "de-DE") return de_de2_workout_after_feedback_lead(inputs)
	if (locale === "it-IT") return it_it2_workout_after_feedback_lead(inputs)
	return en_us2_workout_after_feedback_lead(inputs)
});
export { workout_after_feedback_lead as "workout-after.feedback_lead" }